import { Calendar, User, Clock, Tag } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function BlogMeta({ post, showCategory = true }) {
  const formattedDate = new Date(post.date).toLocaleDateString('en-ZA', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-gray-500 dark:text-gray-400">
      <span className="flex items-center gap-1.5">
        <Calendar className="w-4 h-4" />
        {formattedDate}
      </span>
      <span className="flex items-center gap-1.5">
        <User className="w-4 h-4" />
        {post.author}
      </span>
      <span className="flex items-center gap-1.5">
        <Clock className="w-4 h-4" />
        {post.readingTime} min read
      </span>
      {showCategory && post.category && (
        <Link
          to={`/blog?category=${encodeURIComponent(post.category)}`}
          className="flex items-center gap-1.5 text-emerald-600 dark:text-emerald-400 hover:underline"
        >
          <Tag className="w-4 h-4" />
          {post.category}
        </Link>
      )}
    </div>
  );
}
